// import components
import { showErrorSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

// import hooks
import { useCreateResource } from './useCreateResource';
import { useUpdateResource } from './useUpdateResource';

// import types
import type { AxiosError } from 'axios';
import type { UseSaveResourceParams } from './useSaveResource.types';

export const useSaveResource = ({
  url,
  params,
  id,
  invalidateQueryKey,
  message,
  isCopy
}: UseSaveResourceParams) => {
  'use memo';

  const create = useCreateResource({
    url,
    params,
    invalidateQueryKey,
    message
  });
  const update = useUpdateResource({
    url,
    params,
    id: id!,
    message,
    invalidateQueryKey
  });

  const mutation = !isCopy && id ? update : create;

  const defaultOnError = (error: AxiosError) => {
    message?.error ? showErrorSnackbar(message.error) : showError(error);
  };

  return {
    ...mutation,
    mutate: (
      vars: Parameters<typeof mutation.mutate>[0],
      opts?: Parameters<typeof mutation.mutate>[1]
    ) => {
      mutation.mutate(vars, {
        ...opts,
        onError: opts?.onError ?? defaultOnError
      });
    }
  };
};
